module.exports = __webpack_public_path__ + "img/banner-3-1.b7656f0b.png";